export default "__VITE_ASSET__BmjsgjpA__"